import React from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Icon, message, Upload } from 'antd';
import './index.less';
import { CLIENT_ID } from '../../utils/constants';

class PersonalBasic extends React.Component {
  constructor(props) {
    super(props);
    const {
      userInfo: { face }
    } = props;
    this.state = {
      faceUrl: face ? face : '',
      fileList: [],
      uploading: false
    };
  }

  render() {
    const { intl, userInfo } = this.props;
    const { displayName, dept, email, mobile, staffID } = userInfo;
    const { faceUrl, fileList } = this.state;
    const avatarProps = {
      name: 'fileUpload',
      className: 'avatar-uploader',
      action: `/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
        'token'
      )}&fromType=${CLIENT_ID}`,
      accept: 'image/*',
      multiple: false,
      showUploadList: false,
      beforeUpload: file => {
        this.setState({ uploading: true });
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          message.error(
            intl.formatMessage({ id: 'upload_img_isLt' }, { n: 2 })
          );
        }
        return isLt2M;
      },
      onChange: info => {
        let { fileList } = info;
        let { file } = info;
        if (info.file.status === 'error') {
          message.error(intl.formatMessage({ id: 'image_upload_error' }));
        }
        if (file.response) {
          const result = file.response;
          this.setState({ uploading: false });
          if (result.result === 0) {
            this.setState({ faceUrl: result.list[0].fileUrl });
          } else {
            message.error(intl.formatMessage({ id: 'image_upload_error' }));
          }
        }
        fileList = fileList.slice(-1);
        this.setState({ fileList });
      }
    };

    return (
      <div className="personal-basic">
        <div className="card-title">
          <FormattedMessage id="face_body_face" />
        </div>
        <div className="upload-face">
          <Upload {...avatarProps} fileList={fileList}>
            {faceUrl ? (
              <img src={faceUrl} alt="" className="avatar" />
            ) : (
              <Icon type="plus" className="avatar-uploader-trigger" />
            )}
          </Upload>
          <span className="upload-desc">
            <FormattedMessage
              id="upload_img_tip"
              values={{ w: 300, h: 300, n: 2 }}
            />
          </span>
          <Button type="primary" onClick={this.upload}>
            <FormattedMessage id="btn_save" />
          </Button>
        </div>
        <div className="personal-info">
          <div className="personal-info-title">
            <FormattedMessage id="re_basic_info" />
          </div>
          <div className="personal-info-item">
            <i className="iconfont icon-simpleuser" />
            {displayName}
          </div>
          <div className="personal-info-item">
            <i className="iconfont icon-company" />
            {dept}
          </div>
          <div className="personal-info-item">
            <i className="iconfont icon-emailemail" />
            {email}
          </div>
          <div className="personal-info-item">
            <i className="iconfont icon-mobile" />
            {mobile}
          </div>
          {
            staffID &&
            <div className="personal-info-item">
              <i className="iconfont icon-my"/>
              {staffID}
            </div>
          }
        </div>
      </div>
    );
  }

  upload = () => {
    const { dispatch, loading } = this.props;
    const { faceUrl, uploading } = this.state;
    if (!loading && !uploading) {
      //避免一下连续点击
      dispatch({ type: 'personal/submitFace', faceUrl });
    }
  };
}

const mapStateToProps = state => {
  return {
    userInfo: state.login.userInfo,
    loading: state.loading.models['personal']
  };
};

export default connect(mapStateToProps)(injectIntl(PersonalBasic));



// WEBPACK FOOTER //
// ./src/routes/Personal/PersonalBasic.js